import React, { Component } from 'react';
import { getCurrentResource } from '../../util/tools';
import PlainFullDescription from '../../components/fulldescription/PlainFullDescription';
import styles from '../../components/fulldescription/FullDescription.module.css';
import { FORM_PROVIDER_FT } from '../../util/consts/forms';
import { CLASS_PROVIDER } from '../../util/consts/classes';

class ProviderPage extends Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().pages.plain.Provider;
		this.plainInfo = {
			app: props.app,
			page: this,
			class: CLASS_PROVIDER,
			instanceModelId: FORM_PROVIDER_FT,
			instanceId: this.props.match.params.id,
			param: {}
		};
	}


	render() {
		return (
			<React.Fragment>
				<div className={styles.divPlainTitle}>
					{this.resource.title}
				</div>
				<PlainFullDescription plain={this.plainInfo} />
			</React.Fragment>
		)
	}
}

export default ProviderPage;
